<template>
<v-slide-y-transition>
  <RotatingLogo v-if="visible" class="topdown elevation-10"></RotatingLogo>
</v-slide-y-transition>
</template>

<script>
import RotatingLogo from '@/components/utils/RotatingLogo'

export default {
  name: 'ProgressDialog',
  components: {
    RotatingLogo
  },
  props: {
    visible: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style scoped>
.topdown {
  position: fixed;
  top: 16px;
  left: 50%;
  margin-left: -30px;
}

.slide-y-transition-enter,
.slide-y-transition-leave-to {
  transform: translateY(-100px);
  opacity: 100;
}
</style>
